import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import ConfirmModal from '@mulesoft/exchange-ui-components/lib/components/ConfirmModal';
import Radio from '@mulesoft/anypoint-components/lib/Radio';
import RadioGroup from '@mulesoft/anypoint-components/lib/RadioGroup';
import {
  ScanConfigurationPropType,
  FORM_ASSET_TYPE_LABELS,
  ASSET_TYPE_LABELS
} from '~/components/AgentScanners/types/commonTypes';
import styles from './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ scanConfig, onCancel, onConfirm }) => {
  const assetTypeKey =
    scanConfig.connection?.targetSystem?.assetType?.toLowerCase() || '';
  const assetTypeLabel = FORM_ASSET_TYPE_LABELS[assetTypeKey] || 'Agents';
  const assetTypeSingular = ASSET_TYPE_LABELS[assetTypeKey] || 'Agent';
  const [deleteOption, setDeleteOption] = useState('false');

  const handleConfirm = useCallback(() => {
    onConfirm(deleteOption);
  }, [onConfirm, deleteOption]);

  const onChangeDeleteOption = useCallback((value) => {
    setDeleteOption(value);
  }, []);

  return (
    <ConfirmModal
      title="Delete scanner?"
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      onCancel={onCancel}
      onConfirm={handleConfirm}
      body={
        <div className={styles.deleteModal}>
          <p>
            Deleting {scanConfig.name} {assetTypeSingular} scanner stops
            automatic {assetTypeSingular} discovery and updates.
          </p>
          <p>{`Select an option for imported ${assetTypeLabel}`}</p>
          <RadioGroup
            id="delete-options"
            name="deleteOptions"
            testId="delete-options"
            value={deleteOption}
            orientation="vertical"
            onChange={(event) => onChangeDeleteOption(event.value)}
          >
            <Radio
              testId="delete-options-false"
              label={`Keep imported ${assetTypeLabel} in Exchange`}
              value="false"
              className={styles.deleteModalItem}
            />
            <Radio
              testId="delete-options-true"
              label={`Delete ${assetTypeLabel} from Exchange`}
              value="true"
              className={styles.deleteModalItem}
            />
          </RadioGroup>
        </div>
      }
    />
  );
};

DeleteConfirmModal.propTypes = {
  scanConfig: ScanConfigurationPropType,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default DeleteConfirmModal;
